export class Client {
  clientId!: number;
  name!: string;
  isActive!: boolean;
}
